<div style="display: flex; justify-content: space-between; align-items: center; padding: 10px; flex-shrink: 0;">
  <mat-icon style="visibility: hidden;">close</mat-icon>
  <h2 mat-dialog-title style="margin: 0;">{{data.title}}</h2>
  <div style="display: flex; align-items: center;">
    <mat-icon [mat-dialog-close]="false" style="cursor: pointer;">close</mat-icon>
  </div>
</div>

<mat-dialog-content class="mat-typography custom-dialog-content" [class.no-padding]="data.mode === 'rustdeskIframe'">

  @switch (data.mode) {

  @case ('streaming') {
  <div style="width: 100%; display: flex; flex-direction: column;">
    <streaming style="width: 100%;" [devices]="$any(streamingDevice)"></streaming>
  </div>
  }

  @case ('form') {
  <ng-container [formGroup]="formGroup">
    <div style="display: grid; grid-template-columns: repeat(6, 1fr); gap: 20px; width: 100%;">
      <div *ngFor="let input of data.formData" [style.grid-column]="'span ' + input.length">
        <mat-form-field appearance="outline" [ngSwitch]="input.type" style="width: 100%;">
          <mat-label>{{'FORM.LABELS.'+input.label | translate}}</mat-label>
          <input matInput sanitizeInput [inputRule]="$any(input).inputRule" [placeholder]="$any(input).placeholder"
            [formControlName]="input.id" *ngSwitchDefault>
          <mat-select [formControlName]="input.id" *ngSwitchCase="'select'">
            @for (item of $any(input).values; track item) {
            <mat-option [value]="item.id">{{'FORM.LABELS.'+item.label | translate}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </ng-container>
  }

  @case ('editDeviceName') {
  <div
    style="display: flex; flex-direction: column; width: 100%; align-items: center; justify-content: center; padding: 20px 0;">
    <div class="custom-input">
      <span class="label">MENT-</span>
      <input #inputEl *ngFor="let input of formArray.controls; let i = index" (focus)="handleFocus($event)"
        (keypress)="handleKeyPress($event, i)" (input)="handleInput(i)" (keydown)="handleKeyDown($event, i)"
        [formControl]="$any(input)" type="text" inputmode="numeric" [class.error]="hasError" />
    </div>
    <p style="margin: 15px 0 0 0; color: #ff000091; text-align: center;" *ngIf="hasError">
      {{'GENERAL.ERRORS.DEVICE_NAME_ALREADY_TAKEN' | translate}}
    </p>
  </div>
  }

  @case ('rustdeskIframe') {
  <div style="flex: 1; width: 100%; display: flex; flex-direction: column;">
    <iframe [src]="'http://72.146.154.148:21114/web/?id='+data.additionalData.rustdeskId | safe" width="100%"
      height="100%" frameborder="0" allow="clipboard-read; clipboard-write; autoplay; fullscreen"
      style="background-color: #222; flex: 1;">
    </iframe>
  </div>
  }
  }

  @if(!["streaming", "rustdeskIframe"].includes(data.mode)) {
  <div style="display: flex; justify-content: center; margin-top: 30px;">
    <ion-button color="primary" mode="md"
      [mat-dialog-close]="formArray ? formArray.value : formGroup ? formGroup.value : null"
      [disabled]="saveButtonDisabledStatus">
      {{'GENERAL.BUTTONS.SAVE_AND_CLOSE' | translate}}
    </ion-button>
  </div>
  }

</mat-dialog-content>